import { useState, useEffect } from 'react'
import { api } from '../api/client'

const CHART_BASE = import.meta.env.VITE_API_URL || '/api'

// GET /api/sdata_vector?gh_id=...&year=...&stype=...&sid=...&vtype=...&intervals=...
// stype='YEAR' -> sid='YEAR'; stype='MONTH' -> sid = mesic "01".."12"
export function useWindRoseData({ ghId, year, stype, sid, vtype, intervals }) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!ghId) return
    let cancelled = false
    setLoading(true)
    setError(false)

    const params = new URLSearchParams({
      gh_id: ghId,
      year: String(year),
      stype,
      sid,
      vtype,
      intervals: String(intervals),
    })

    api.get(`/sdata_vector?${params}`)
      .then(d => { if (!cancelled) { setData(d); setLoading(false) } })
      .catch(e => {
        if (cancelled) return
        if (e.status === 404) { setData(null); setLoading(false); return }
        console.error('[useWindRoseData] Chyba:', e)
        setError(true)
        setLoading(false)
      })

    return () => { cancelled = true }
  }, [ghId, year, stype, sid, vtype, intervals])

  return { data, loading, error }
}

// Menší než 700x700 z configu (wr_month.json/wr_year.json) — width/height jsou
// v ChartHandler override configu, takže se zmenší i vykreslený obrázek, ne jen CSS.
const CHART_SIZE = 500

// GET /chart?type=windrose&cfg=wr_month|wr_year&station=...&from=...&to=...&stype=...&vtype=...&intervals=...&format=...
export function buildWindRoseChartUrl({ station, stype, from, to, vtype, intervals, format }) {
  const cfg = stype === 'MONTH' ? 'wr_month' : 'wr_year'
  const params = new URLSearchParams({
    type: 'windrose',
    cfg,
    station,
    from,
    to,
    stype,
    vtype,
    intervals: String(intervals),
    format,
    width: String(CHART_SIZE),
    height: String(CHART_SIZE),
  })
  return `${CHART_BASE}/chart?${params}`
}

function pad2(n) {
  return String(n).padStart(2, '0')
}

export function calcMonthFromTo(year, month) {
  const lastDay = new Date(year, month, 0).getDate()
  return {
    from: `${year}${pad2(month)}010000`,
    to: `${year}${pad2(month)}${pad2(lastDay)}2359`,
  }
}

export function calcYearFromTo(year) {
  return {
    from: `${year}01010000`,
    to: `${year}12312359`,
  }
}
